'use client'

import { useTranslations } from 'next-intl'

import { RoomThumbnail, TRecentViewedRoom } from '@/entities/room'
import { LikeButton } from '@/features/toggle-favorite-room'
import { Link } from '@/shared/i18n'
import { useFormatCurrency } from '@/shared/lib'

export const RoomCard = ({
  rid,
  picMain,
  province,
  town,
  propertyType,
  usingFee,
  mgmtFee,
  like,
}: TRecentViewedRoom) => {
  const t = useTranslations()

  const { formatCurrency } = useFormatCurrency()

  const title = t('recent_room.roomName', {
    address: `${province} ${town}`,
    propertyType,
  })

  return (
    <Link
      href={`/guest/room/${rid}`}
      className="bg-gray-0 flex w-[343px] items-center gap-4 rounded-sm py-5 pr-4.5 pl-5"
      target="_blank"
    >
      <RoomThumbnail
        src={picMain}
        alt={title}
        rounded
        ratio="1:1"
        size={84}
        unoptimized
      />
      <div className="min-w-0 flex-1 space-y-2.5">
        <p className="typo-body1 line-clamp-2 font-normal text-gray-700">
          {title}
        </p>
        <div className="flex items-center gap-0.5">
          <p className="typo-headline3 flex items-center gap-px font-semibold text-gray-900">
            {formatCurrency(usingFee + mgmtFee, {
              unit: chunks => <span className="typo-label1">{chunks}</span>,
            })}
          </p>
          <span className="typo-headline3 w-3 text-center font-light text-gray-200">
            /
          </span>
          <span className="typo-body1 font-bold text-gray-600">
            {t('common.week_unit')}
          </span>
        </div>
      </div>
      <LikeButton roomId={rid} like={like} className="self-start p-0" />
    </Link>
  )
}
